export default "<div class=\"progress-cont\">\r\n    <div class=\"progress\" [style.width]=\"progress + '%'\">\r\n    </div>\r\n  </div>\r\n  "